import type { Patient, Reference } from '@medplum/fhirtypes'
import type { StandardTask } from '@seen/core/models/tasks/standard/standardTask'
import type { JSX } from 'react'
import { TaskListRow } from '#src/components/task/list/TaskListRow.tsx'
import type { TaskComposerDefaultValues } from '#src/hooks/useTaskComposerStore.ts'
import { useTaskListItems } from '#src/hooks/useTaskListItems.ts'

export interface TaskListProps {
  tasks: StandardTask[] | undefined
  defaultValues?: TaskComposerDefaultValues
  participant?: Reference<Patient>
  hideOrder?: boolean
}

export function TaskList({
  tasks,
  defaultValues,
  participant,
  hideOrder,
}: TaskListProps): JSX.Element {
  const items = useTaskListItems(tasks)

  return (
    <div>
      {items.map((item) => (
        <TaskListRow
          key={item.key}
          item={item}
          defaultValues={defaultValues}
          participant={participant}
          hideOrder={hideOrder}
        />
      ))}
    </div>
  )
}
